/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import {Action} from 'vuex-class';
import {ActiveCommunityChallengeStateInterface} from '@/store/modules/community-challenge/types';
import CommunityChallengeActiveItem from '@/mixins/CommunityChallengeActiveItem';
// import ConnectionProblem from '@/components/ConnectionProblem/index.vue';
import Utils from '@/services/utils';

/**
 * Community Challenges preview.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'v-community-challenge-preview',
    components: {
        // 'c-connection-problem': ConnectionProblem,
    },
})
export default class CommunityChallengePreview extends mixins(CommunityChallengeActiveItem) {
    @Action('getCurrentChallenge', {namespace: 'communityChallengeModule'})
    public getCurrentChallenge!: () => ActiveCommunityChallengeStateInterface;

    public loading: boolean = true;

    /**
     * Runs when view is created
     */
    public async created(): Promise<void> {
        this.loading = true;
        try {
            await Utils.timeout(1000);
            await this.getCurrentChallenge();
        } catch (e) {
            // do nothing
        }
        this.loading = false;
    }

    /**
     * Challenge active getter.
     * @return {boolean}
     */
    public get activeChallenge(): boolean {
        return !!this.challenge && !this.challenge.expired;
    }
}
